import React from 'react';

import { Route, RouteComponentProps, Switch } from 'react-router';

import LazyComponent from '@fd/ui/LazyComponent';

import { lazyWithRetry } from '../../helpers/utilities';
import ErrorBoundary from '../../layouts/Portal/ErrorBoundary';

const MicroFrontendOnboardingInternalTools = lazyWithRetry(
  () => import('./OnboardingInternalTools')
);
type Props = RouteComponentProps;

const OnboardingInternalToolsRoutes: React.FC<Props> = (props: Props) => {
  const {
    match: { path },
  } = props;

  return (
    <ErrorBoundary identifier="onboarding-internal-tools-mf">
      <Switch>
        <Route
          path={`${path}`}
          render={() => (
            <LazyComponent>
              <MicroFrontendOnboardingInternalTools />
            </LazyComponent>
          )}
        />
      </Switch>
    </ErrorBoundary>
  );
};

export default OnboardingInternalToolsRoutes;
